<template>
  <div class="tab__item clear" :class="{ noItems: noItems }">
    <div class="table__title">
      <div class="table__title--text">{{ title }}</div>
    </div>
    <table class="maincol__table">
      <tr class="table__row" v-if="loading">
        <td class="table__cell h-center-align" colspan="20"><pulse-loader :loading="loading"></pulse-loader></td>
      </tr>
      <tr class="table__row--head table__row table__row--short" v-if="filteredItems.length > 0">
        <td :class="{ 'table__cell--active-sort': sortProp === 'family' }" class="table__cell table__cell--medium" @click="sortBy('family')">Family <span class="glyphicon glyphicon--table-sorter" :class="sortClass" aria-hidden="true" v-show="sortProp === 'family'"></span></td>
        <td :class="{ 'table__cell--active-sort': sortProp === 'product'}" class="table__cell table__cell--medium" @click="sortBy('product')">Product <span class="glyphicon glyphicon--table-sorter" :class="sortClass" aria-hidden="true" v-show="sortProp === 'product'"></span></td>
        <td :class="{ 'table__cell--active-sort': sortProp === 'item_number'}" class="table__cell table__cell--medium" @click="sortBy('item_number')">Item Number <span class="glyphicon glyphicon--table-sorter" :class="sortClass" aria-hidden="true" v-show="sortProp === 'item_number'"></span></td>
        <td :class="{ 'table__cell--active-sort': sortProp === 'tier'}" class="table__cell table__cell--small" @click="sortBy('tier')">Tier <span class="glyphicon glyphicon--table-sorter" :class="sortClass" aria-hidden="true" v-show="sortProp === 'tier'"></span></td>
        <td :class="{ 'table__cell--active-sort': sortProp === 'warranty'}" class="table__cell table__cell--small" @click="sortBy('warranty')">Warranty <span class="glyphicon glyphicon--table-sorter" :class="sortClass" aria-hidden="true" v-show="sortProp === 'warranty'"></span></td>
        <td :class="{ 'table__cell--active-sort': sortProp === 'list_price'}" class="table__cell table__cell--small" @click="sortBy('list_price')">List Price <span class="glyphicon glyphicon--table-sorter" :class="sortClass" aria-hidden="true" v-show="sortProp === 'list_price'"></span></td>
        <td :class="{ 'table__cell--active-sort': sortProp === 'fuel_member_price'}" class="table__cell table__cell--small" @click="sortBy('fuel_member_price')">Member Price <span class="glyphicon glyphicon--table-sorter" :class="sortClass" aria-hidden="true" v-show="sortProp === 'fuel_member_price'"></span></td>
      </tr>
      <Item v-for="(item, index) in filteredItems" v-if="!loading" :key=index :item="item"></Item>
    </table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import { BeatLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import Item from './Item.vue';
  import FuelUtilities from '../utils/FuelUtilities';
  import TableFunctionality from '../utils/TableFunctionality.vue';

  export default {
    mixins: [FuelUtilities, TableFunctionality],
    components: {
      Item,
      BeatLoader,
      PulseLoader,
    },
    props: ['selectedManufacturer', 'selectedMfgObject'],
    data() {
      return {
        title: 'Items',
        defaultItemsPerPage: 10,
        baseUrl: '',
        viewAllTitle: 'View All',
        defaultSortDir: 'asc',
        defaultSortProp: 'family',
        isInitialized: false,
        itemsPerPage: 10,
        currentPageItems: [],
        filteredItems: [],
        isLoading: false,
        sortDir: 'asc',
        sortProp: 'family',
        searchFields: ['family', 'product', 'item_number', 'tier', 'warranty'],
      }
    },
    async mounted() {
      this.initialize();
      this.filteredItems = this.selectedMfgObject.items;
    },
    watch: {
      selectedMfgObject() {
        this.filteredItems = this.selectedMfgObject.items;
      },
      searchString(newVal, oldVal) {
        // if search is being reset to empty
        this.searchString === '' ? this.filteredItems = this.selectedMfgObject.items : this.filterByString();
      },
      sortDir() {
        this.$store.dispatch('pricingGuides/setSortDir', this.sortDir);
      },
      sortProp() {
        this.$store.dispatch('pricingGuides/setSortProp', this.sortProp);
      },
    },
    computed: {
      ...mapGetters('pricingGuides', ['manufacturers', 'pricing', 'loaders']),
      loading() {
        return this.loaders.pricing;
      },
      selectedMfgNameSlug() {
        return this.selectedManufacturer ? this.selectedManufacturer.toLowerCase() : null;
      },
    },
  }
</script>
